import { render, staticRenderFns } from "./AtualizaSituacaoAgendamento.vue?vue&type=template&id=f96c74a8"
import script from "./AtualizaSituacaoAgendamento.vue?vue&type=script&lang=ts"
export * from "./AtualizaSituacaoAgendamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports